/* unplugin-vue-components disabled */import script from "./assist.vue?vue&type=script&setup=true&lang=js"
export * from "./assist.vue?vue&type=script&setup=true&lang=js"

import "./assist.vue?vue&type=style&index=0&id=376b3724&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-376b3724"]])

export default __exports__